import commonFunc from '../../api/common/common.js'
// import dynamicRouter from '@/router/dynamic-router'
// import router, { DynamicRoutes } from '@/router/index'
// import PageIndex from '@/pages/PageIndex'
// import Index from '@/pages/Index'
// moduleA
// 单一状态树，用一个对象就包含了全部的应用层级状态。
// 至此它便作为一个“唯一数据源 (SSOT)”而存在。
const state = {
    userInfoObj: {},
    isLogin: false,
    // permissionList: []
}

// getters
const getters = {
    getUserInfoObj: state => {
        return state.userInfoObj
    },
    getLoginStatus () {
        return state.isLogin
    },
    // getPermissionList () {
    //     return state.permissionList
    // }
}

// 更改 Vuex 的 store 中的状态的唯一方法是提交 mutation
// Vuex 中的 mutation 非常类似于事件：每个 mutation 都有一个字符串的 事件类型 (type) 和 一个 回调函数 (handler)。
const mutations = {
    setUserInfo (state, dataObj) {
        state.userInfoObj = dataObj
        state.isLogin = true
        sessionStorage.setItem('userInfoObj', JSON.stringify(dataObj)); //添加备份数据到sessionStorage
        sessionStorage.setItem('isLogin', true);
    },
    clearUserInfo (state) {
        state.userInfoObj = ''
        state.isLogin = false
        sessionStorage.removeItem('userInfoObj'); //清除用户数据
        sessionStorage.removeItem('isLogin');
    },
    setLogin (state) {
      if (!state.isLogin) {
        state.userInfoObj = JSON.parse(sessionStorage.getItem('userInfoObj'));
        state.isLogin = sessionStorage.getItem('isLogin'); //从sessionStorage中读取状态
      }
    },
    // setPermissionList (state, dataObj) {
    //     state.permissionList = dataObj
    //     sessionStorage.setItem('permissionList', JSON.stringify(dataObj)); //添加备份数据到sessionStorage
    // },
    // clearPermissionList (state) {
    //     state.permissionList = ''
    //     sessionStorage.removeItem('permissionList'); //添加备份数据到sessionStorage
    // },
}

// Action 类似于 mutation，不同在于：
// Action 提交的是 mutation，而不是直接变更状态。
// Action 可以包含任意异步操作。context包含 state, commit, rootState
const actions = {
    async getServerData (context, paramsObj) {
        // 调用Api接口(对传入参数进行过滤，如果需要对传如api的参数进行重组可在此操作，无操作直接传入即可)
        context.commit('setUserInfo', paramsObj)
    },
    doClearUserInfo (context) {
      context.commit('clearUserInfo')
    },
    doSetLogin (context) {
      context.commit('setLogin')
    },
    // doSetPermissionList (context, paramsObj) {
    //     context.commit('setPermissionList', paramsObj)
    // },
    // doClearPermissionList (context) {
    //   context.commit('clearPermissionList')
    // },
}

export default {namespaced: true, state, getters, actions, mutations}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js